import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {SiteModel} from '../../../../models/SiteModel';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {OrganizationUnitModel} from '../../../../models/OrganizationUnitModel';
import {OrganizationUnitAnagrafService} from '../../../general-services/service-organization-unit-anagraf/organization-unit-anagraf.service';
import {LoaderService} from '../../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-edit-organization-unit-anagraf',
  templateUrl: './edit-organization-unit-anagraf.component.html',
  styleUrls: ['./edit-organization-unit-anagraf.component.scss']
})
export class EditOrganizationUnitAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  organizationUnit: OrganizationUnitModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  parameterSubscribe: Subscription;
  saveSubscribe: Subscription;
  submitted = false;

  id: number;
  organizationUnitCod: string;
  description: string;
  organizationUnitJson: any;

  constructor(private route: ActivatedRoute, private router: Router,
              private organizationUnitAnagrafService: OrganizationUnitAnagrafService,
              private _activatedRoute: ActivatedRoute, private loaderService: LoaderService) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.organizationUnitJson = params['row'];
      });

    this.organizationUnit = new SiteModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });
    this.organizationUnit = JSON.parse(this.organizationUnitJson) as SiteModel;

    this.formValidator.patchValue({
      cod: this.organizationUnit ? this.organizationUnit.cod : ''
    });

    this.formValidator.patchValue({
      description: this.organizationUnit ? this.organizationUnit.description : ''
    });

    _activatedRoute.params.subscribe(params => {
      this.id = params['id'];
      this.organizationUnitCod = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
  //  this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.ORGANIZATION_UNIT_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.organizationUnit.cod = this.formValidator.controls['cod'].value;
      this.organizationUnit.description = this.formValidator.controls['description'].value;
      this.saveSubscribe =
        this.organizationUnitAnagrafService.update(this.organizationUnitAnagrafService.baseUrl, this.organizationUnit).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Organization Unit Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('Organization Unit was edited with success', 'Success');
       //     this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.ORGANIZATION_UNIT_ANAGRF]);
          }
        }, error => {
            this.loaderService.display(false);
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.formValidator.controls; }

}
